



























































































































import { Vue, Component, Emit } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { companyServer, institutionServer, performanceServer, professionServer, regionServe, spaceServe } from '@/api/installServer';
import publicProp from '@/views/doublePrevention/hazardChecklist/publicProp.vue';
import { doublePrevention } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: { PagingUnit, CollapseTransition, publicProp },
  mixins: [TableStripe],
})
export default class HazardChecklist extends Vue {
  private rowId: any = {};
  private searchForm: any = {
    riskLevel: '', // 风险等级
    search: '', // 模糊搜索
    hazardCategoryTagId: '', // 隐患分类
    postId: '', // 岗位
    areaId: '', // 区域
    riskPointId: '', // 风险点
    sourceName: '', // 安全还是环保
  };
  private subSpaceByAuthOptions: any = []; // 区域列表
  private riskPointList: any = []; // 风险点的下拉
  private sourceNameList: any = [
    {
      value: '安全类隐患排查清单',
    },
    {
      value: '环保隐患排查清单',
    },
  ];
  private riskLevelList: any = [
    {
      value: '重大风险',
    },
    {
      value: '较大风险',
    },
    {
      value: '一般风险',
    },
    {
      value: '低风险',
    },
  ];
  private tableData: any = [];
  private hazardCategoryTagIdList: any = [];
  private postIdList: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;

  private multipleSelection: any = [];

  private userInfo: any = {};

  private onSearch() {
    this.getTableData();
  }

  private onreset() {
    this.searchForm = {
      riskLevel: '', // 风险等级
      hazardDesc: '', // 隐患描述
      hiddenCode: '', // 隐患代码

      search: '', // 模糊搜索
      hazardCategoryTagId: '', // 隐患分类
      postId: '', // 岗位
      areaId: this.userInfo.areaId, // 区域
      riskPointId: '', // 风险点
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getTableData() {
    doublePrevention
      .getRiskControlInventoryHazard({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        search: this.searchForm.search ? this.searchForm.search : null, // 模糊搜索
        riskLevel: this.searchForm.riskLevel ? this.searchForm.riskLevel : null, // 隐患等级
        hazardCategoryTagId: this.searchForm.hazardCategoryTagId ? this.searchForm.hazardCategoryTagId : null, // 隐患分类
        postId: this.searchForm.postId ? this.searchForm.postId : null, // 岗位
        areaId: this.searchForm.areaId ? this.searchForm.areaId : null, // 区域
        riskPointId: this.searchForm.riskPointId ? this.searchForm.riskPointId : null, // 风险点
        sourceName: this.searchForm.sourceName ? this.searchForm.sourceName : null, // 安全/环保
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  private getListData() {
    this.getTableData();
  }

  private showPublicProp(type: any, data: any) {
    this.rowId.data = data;
    this.rowId.type = type;
    if (type !== 'delete') {
      // 详情、编辑、添加的弹窗
      (this.$refs as any).publicProp.showDialog();
    } else {
      this.deleteRiskControlInventoryHazard();
    }
    // console.log(type, data);
  }

  // 删除
  deleteRiskControlInventoryHazard() {
    // console.log(this.rowId.data.id);
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.deleteRiskControlInventoryHazard(this.rowId.data.id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('成功删除该条数据！');
            this.queryDataForm = {
              pageNo: 1,
              pageSize: 10,
            };
            this.searchForm = {};
            this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  private getHazardCategoryTagIdList() {
    performanceServer
      .getTagManageList({ type: 'hazardClassify' })
      .then((res: any) => {
        this.hazardCategoryTagIdList = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  public getAllPostList() {
    professionServer
      .getPageDataAll({})
      .then((res: any) => {
        this.postIdList = res.data;
      })
      .catch((error: any) => {
        this.$message.warning('获取岗位的数据失败！');
      });
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe
      .getAreaAndSubAreaList({ areaId: this.userInfo.areaId })
      .then((res: any) => {
        if (res.code === '200') {
          this.subSpaceByAuthOptions = arrayToTree(res.data);
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  tableAreaChange(e: any) {
    this.riskPointList = [];
    this.searchForm.riskPointId = '';
    if (e) {
      this.getRiskAndDangerList();
    }
  }
  private getRiskAndDangerList() {
    doublePrevention
      .getRiskAll({
        areaId: this.searchForm.areaId,
        type: '风险点',
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.riskPointList = res.data;
        } else {
          this.$message.warning('获取风险点和危险源的数据失败！');
        }
      });
  }

  async created() {
    this.userInfo = JSON.parse((localStorage as any).getItem('userInfo'));
    this.searchForm.areaId = this.userInfo.areaId;
    this.getRiskAndDangerList();
    this.getTableData();
    await this.getSpaceAreaData();
    this.getHazardCategoryTagIdList();
    this.getAllPostList();
  }
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  exportList() {
    this.$confirm(`导出数据是否继续？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportOperateApi();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }
  exportOperateApi() {
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: publishObjectPath.serverUrl + '/api/yunnan/riskControlInventoryHazard/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        search: this.searchForm.search ? this.searchForm.search : null, // 模糊搜索
        riskLevel: this.searchForm.riskLevel ? this.searchForm.riskLevel : null, // 隐患等级
        hazardCategoryTagId: this.searchForm.hazardCategoryTagId ? this.searchForm.hazardCategoryTagId : null, // 隐患分类
        postId: this.searchForm.postId ? this.searchForm.postId : null, // 岗位
        areaId: this.searchForm.areaId ? this.searchForm.areaId : null, // 区域
        riskPointId: this.searchForm.riskPointId ? this.searchForm.riskPointId : null, // 风险点
        sourceName: this.searchForm.sourceName ? this.searchForm.sourceName : null, // 安全/环保
        idList: this.multipleSelection.map((item: any) => {
          return item.id;
        }),
      },
    })
      .then((response: any) => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message.success('导出成功!');
      })
      .catch((error: any) => {
        console.log(error, 'error');
        loading.close();
        this.$message.error('导出失败,请联系管理员!');
      });
  }
}
